import PropTypes from 'prop-types';
import { Modal, ModalTitle, ModalBody, ModalFooter, CloseButton } from 'react-bootstrap';
import ModalButtons from './ModalButtons';

const CustomModal = ({
  title,
  children,
  show = false,
  close,
  buttons = [],
  size = 'md',
  justifyContentButtons = 'end',
  closeEnable = true,
  fontSize = '1.3rem',
}) => {
  const handleClose = () => {
    close();
  };

  return (
    <Modal
      data-test-id='modal'
      size={size}
      show={show}
      onHide={closeEnable ? handleClose : () => {}}
      centered
    >
      <Modal.Header className='justify-content-center'>
        <ModalTitle>{title}</ModalTitle>
        {closeEnable && (
          <CloseButton
            data-test-id='modal-close'
            onClick={close}
            className='bg-transparent border-0 position-absolute end-0 me-3'
            style={{ transform: 'scale(1.5)' }}
          />
        )}
      </Modal.Header>
      <ModalBody style={{ fontSize }}>{children}</ModalBody>
      {buttons.length > 0 && (
        <ModalFooter>
          <ModalButtons
            className={`d-flex justify-content-${justifyContentButtons} gap-2 w-100`}
            buttons={buttons}
          />
        </ModalFooter>
      )}
    </Modal>
  );
};

CustomModal.proptypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  close: PropTypes.func.isRequired,
  show: PropTypes.bool,
  size: PropTypes.string,
  justifyContentButtons: PropTypes.string,
  closeEnable: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      className: PropTypes.string,
      style: PropTypes.object,
      action: PropTypes.func,
    }),
  ),
};

export default CustomModal;
